/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['[_nghost-%COMP%] {\n	height: 100%;\n	min-height: 130px;\n	display: block;\n}\n\n.app-modal-title[_ngcontent-%COMP%] {\n	height: 30%;\n}\n.app-modal-content[_ngcontent-%COMP%] {\n	height: 55%;\n	text-align: center;\n	font-size: 16px;\n}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL29wdC9qZW5raW5zL3dvcmtzcGFjZS9naXNlbGFfcG9ydGFsL3NyYy9hcHAvY29tcG9uZW50cy9tb2RhbC1pZGxlL21vZGFsLWlkbGUuY29tcG9uZW50LmNzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9vcHQvamVua2lucy93b3Jrc3BhY2UvZ2lzZWxhX3BvcnRhbC9zcmMvYXBwL2NvbXBvbmVudHMvbW9kYWwtaWRsZS9tb2RhbC1pZGxlLmNvbXBvbmVudC5jc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/app/components/modal-idle/modal-idle.component.css.shim.ngstyle.ts